<div class="footer-bar"></div>
<footer class="footer container--nav">
  <div class="footer__bottom">
    <!-- <p class="footer__copyright" [innerHTML]="copyright"></p> -->
    @if (pages$ | async; as _pages) {
      <ul class="footer-links-list">
        @for (page of _pages | orderBy: ['displayOrder']; track page) {
          @if (
            page.meta.showFooterBar === "'true'" ||
            page.meta.showFooterBar === true ||
            page.meta.showFooterBar === 'true'
          ) {
            <li class="footer-links-list__item">
              <a
                [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url"
                [core-analytics]="{ action: page.url, category: 'FOOTER' }"
                class="footer-links-list__link"
                >{{ page.name | translate }}</a
              >
            </li>
          }
        }
        <li class="footer-links-list__item">
          <a
            [core-analytics]="{ action: 'Cookie policy', category: 'FOOTER' }"
            class="footer-links-list__link"
            href="//policy.cookiereports.com/1b71f3ca-en-gb.html"
            >{{ 'Cookie Policy' | translate }}</a
          >
        </li>
      </ul>
    }
  </div>
</footer>
